import { useToast } from 'contexts/ToastContext'
import { usePatchShoppingCart } from 'features/ECommerce/api/mutations/usePatchShoppingCart'
import { usePostShoppingCart } from 'features/ECommerce/api/mutations/usePostShoppingCart'
import { useFetchShoppingCart } from 'features/ECommerce/api/queries/useFetchShoppingCart'
import { useTranslation } from 'hooks/useTranslation'

export const useAddToCart = () => {
  const { t } = useTranslation()
  const { addToast, removeToast } = useToast()

  const { postShoppingCart } = usePostShoppingCart()
  const { patchShoppingCart } = usePatchShoppingCart()

  const { data: shoppingCart } = useFetchShoppingCart({})

  const getItems = (productId: string, quantity: number) => {
    if (!shoppingCart) {
      return {
        items: [
          {
            productId,
            quantity,
          },
        ],
      }
    }

    return {
      items: shoppingCart?.items.some((item) => item.productId === productId)
        ? shoppingCart?.items.map((item) =>
            item.productId === productId ? { ...item, quantity: item.quantity + quantity } : item
          )
        : [
            ...(shoppingCart?.items || []),
            {
              productId,
              quantity,
            },
          ],
    }
  }

  return (productId: string, quantity = 1, productName: string) => {
    const items = getItems(productId, quantity)

    const mutation = shoppingCart ? patchShoppingCart : postShoppingCart

    mutation(items, {
      onSuccess: () => {
        addToast({
          message: t('e-commerce-toasts:add.success.message', { productName }),
          duration: 5000,
          onClose: () => removeToast(`cart-add-success-${productId}`),
          tone: 'success',
          id: `cart-add-success-${productId}`,
        })
      },
      onError: () => {
        addToast({
          title: t('e-commerce-toasts:add.error.title'),
          message: t('e-commerce-toasts:add.error.message'),
          duration: 5000,
          onClose: () => removeToast(`cart-add-error-${productId}`),
          tone: 'error',
          id: `cart-add-error-${productId}`,
        })
      },
    })
  }
}
